import type { ApiResult } from "@wiseowl/shared";

const BASE = import.meta.env.VITE_API_BASE_URL ?? "";

/**
 * Thin fetch wrapper that returns the worker's `ApiResult<T>` envelope
 * untouched. Components can pattern-match on `isApiError(result)` from
 * `@wiseowl/shared` rather than guessing at fetch's exception model.
 */
export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<ApiResult<T>> {
  const token = localStorage.getItem("wo.token");
  const headers = new Headers(init.headers);
  headers.set("Content-Type", "application/json");
  if (token) headers.set("Authorization", `Bearer ${token}`);

  let res: Response;
  try {
    res = await fetch(`${BASE}/api${path}`, { ...init, headers });
  } catch (err) {
    return {
      error: {
        code: "network_error",
        message: err instanceof Error ? err.message : "Network request failed",
      },
    };
  }

  // 204 has no body — surface as `{ data: undefined as T }`.
  if (res.status === 204) return { data: undefined as T };

  const body = (await res.json().catch(() => null)) as ApiResult<T> | null;
  if (!body) {
    return {
      error: { code: "invalid_response", message: `HTTP ${res.status}` },
    };
  }
  return body;
}
